import * as Yup from 'yup';

// Equipment created before an invoice file existed can legitimately have no
// file on record, so the field must stay optional in that case. Once a file
// exists, it can't be cleared without being replaced.
const requiredIfHadFile = (hadFile, requiredMessage) =>
  Yup.mixed()
    .nullable()
    .test(requiredMessage, requiredMessage, value => !hadFile || Boolean(value));

export default ({ invoicePdfUrl, invoiceXmlUrl }) =>
  Yup.object().shape({
    price: Yup.number()
      .typeError('SCHEMA_ERRORS.VALUE_REQUIRED')
      .min(1, 'SCHEMA_ERRORS.COMMON.IVA_GREATER_THAN_ZERO')
      .required('SCHEMA_ERRORS.EQUIPMENT_FORM.PRICE_REQUIRED'),
    iva: Yup.number()
      .typeError('SCHEMA_ERRORS.VALUE_REQUIRED')
      .min(1, 'SCHEMA_ERRORS.COMMON.IVA_GREATER_THAN_ZERO')
      .max(100, 'SCHEMA_ERRORS.EQUIPMENT_FORM.IVA_LESS_THAN_ONE')
      .required('SCHEMA_ERRORS.EQUIPMENT_FORM.IVA_REQUIRED'),
    invoicePdfUrl: requiredIfHadFile(
      Boolean(invoicePdfUrl),
      'SCHEMA_ERRORS.EQUIPMENT_FORM.INVOICE_PDF_REQUIRED'
    ),
    invoiceXmlUrl: requiredIfHadFile(
      Boolean(invoiceXmlUrl),
      'SCHEMA_ERRORS.EQUIPMENT_FORM.INVOICE_XML_REQUIRED'
    )
  });
